import {Component, inject, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {WinOlsCustomersService} from '../service/Win-ols-customers.service';
import {WinOlsCustomersModel} from '../models/WinOlsCustomers-Model';
import {AuthService} from '../service/auth.service';
import {fadeInAnimation} from '../animations/fadeInAnimation';


@Component({
    selector: 'app-win-ols-customers',
    templateUrl: './win-ols-customers.component.html',
    styleUrls: ['./win-ols-customers.component.css'],
    animations: [fadeInAnimation],
    host: {'[@fadeInAnimation]': ''}

})
export class WinOlsCustomersComponent implements OnInit, OnDestroy {

    public winOlsCustomersService = inject(WinOlsCustomersService);
    @ViewChild('tableContainer', {static: false}) tableContainer!: ElementRef;

    authService = inject(AuthService) as AuthService;


    searchQuery: string = '';

    ngOnInit() {
        this.getWinOlsCustomers();
    }

    ngOnDestroy() {
        this.winOlsCustomersService.resetComponentState();
    }

    getWinOlsCustomers() {
        this.winOlsCustomersService.getWinOlsCustomersTable();
    }


    onSearchInput(event: any) {
        this.searchQuery = event.target.value;
        this.winOlsCustomersService.searchWinOlsCustomers(this.searchQuery);
    }

    onSearchClick() {
        if (this.searchQuery.trim().length >= 3) {
            this.winOlsCustomersService.searchWinOlsCustomers(this.searchQuery);
        }
    }

    onClearSearch() {
        this.searchQuery = '';
        this.winOlsCustomersService.clearSearch();
    }

    onAddItems() {
        this.winOlsCustomersService.openNewRow();
    }

    saveNewRow() {
        this.winOlsCustomersService.addWinOlsCustomer();
    }

    deleteRow() {
        this.winOlsCustomersService.editInputRow.set(false);
    }

    onChangeSubscription(element: WinOlsCustomersModel, event: Event) {
        const select = event.target as HTMLSelectElement;
        element.emailSubscribed = select.value === 'true';
        this.winOlsCustomersService.updateCustomerSubscription(element);
    }

    onEditItems(index: number) {
        this.winOlsCustomersService.customerIndex.set(index);
    }

    onSaveItems(element: WinOlsCustomersModel) {
        this.winOlsCustomersService.updateWinOlsCustomer(element);
    }

    onDeleteItems(element: WinOlsCustomersModel) {
        this.winOlsCustomersService.deleteWinOlsCustomer(element);
    }

    onExitItems() {
        this.winOlsCustomersService.customerIndex.set(null);
    }

    onScroll() {
        this.winOlsCustomersService.onScroll();
    }

    changeSortDirection(column: string) {
        const currentSort = this.winOlsCustomersService.sortDirectionValues();
        let newDirection: 'asc' | 'desc' = 'asc';

        if (currentSort.active === column) {
            newDirection = currentSort.direction === 'asc' ? 'desc' : 'asc';
        }

        this.winOlsCustomersService.changeSortDirection(
            {active: column, direction: newDirection},
            this.tableContainer?.nativeElement
        );
    }

    onMobileSortColumn(event: Event) {
        const column = (event.target as HTMLSelectElement).value;
        this.winOlsCustomersService.changeSortDirection(
            {active: column, direction: this.winOlsCustomersService.sortDirectionValues().direction},
            this.tableContainer?.nativeElement
        );
    }

    onRefreshTable() {
        this.searchQuery = '';
        this.winOlsCustomersService.onRefreshTable();
    }

    hasPermission() {
        return this.authService.isSuperAdmin();
    }
}
